import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/data/site";
import Reveal from "@/components/ui/reveal";

export default function Faq() {
    return (
        <section id="faq" className="border-t border-border py-20 lg:py-28">
            <div className="container-gr grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">FAQ</p>
                    <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">Masz pytania?<br />Mamy odpowiedzi.</h2>
                    <p className="mt-4 text-muted-foreground">Nie znalazłeś tego, czego szukasz? Formularz kontaktowy udostępnimy wkrótce.</p>
                </div>
                <Reveal className="lg:col-span-8">
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQ.map((f, i) => (
                            <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
                                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-heading text-base font-bold text-foreground hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm leading-relaxed text-muted-foreground">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
